<!-- 页面内容 -->
<template>
	<div class="">
		<el-select
			v-if="props.cssType==1"
			class="language_box1"
			v-model="currentLanguage"
		>
			<el-option
				v-for="item in langType"
				:key="item.value"
				:label="item.name"
				:value="item.value"
			/>
		</el-select>
	</div>
</template>

<script setup lang="ts">
import { useLocale } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { defineProps, ref, watch } from 'vue';
import { useUserStore } from '@/store/user';

const userBase = useUserStore();

const props = defineProps({
	cssType: {
		type: String,
		default: '1'
	}
});

interface LangType {
	name: string;
	value: string;
}

const langType: Array<LangType> = [
	{ name: '中文', value: 'zh' },
	{ name: 'English', value: 'en' }
];

const { locale } = useLocale();
const i18n = useI18n();

const { bus } = useBus();

import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import en from 'element-plus/dist/locale/en.mjs';
import { useBus } from '@/common/utils/useBus';
const currentLanguage = ref(localStorage.getItem('lang') || 'zh');
watch(currentLanguage, () => {
	localStorage.setItem('lang', currentLanguage.value);
	if (currentLanguage.value == 'zh') {
		locale.value = zhCn;
		userBase.language = 'zh';
	} else {
		locale.value = en;
		userBase.language = 'en';
	}
	i18n.locale.value = currentLanguage.value;
	bus.emit('UPDATE_LANGUAGE');
});
</script>

<style lang='scss' scoped>
:deep(.language_box1) {
	width: 144px !important;
}
</style>